import React from "react";
import "./Faq.css";

function Faq() {

  const faqs = [
    {
      question: "1. What are SAH? scented pouches?",
      answer:
        "Premium scented pouches designed for your car, closet, drawers, and any space you want to refresh. Each scent is crafted to match a mood or vibe.",
    },
    {
      question: "2. How long does the scent last?",
      answer:
        "Each pouch lasts 30-60 days depending on placement and airflow. For best results, gently squeeze the pouch to refresh the scent.",
    },
    {
      question: "3. Where can I use them?",
      answer:
        "Anywhere! Car, closet, gym bag, office drawer, luggage, bathroom, or any small space that needs a mood boost.",
    },
    {
      question: "4. How do I activate the scent?",
      answer:
        "Simply remove from packaging and place it in your desired space. Gently squeeze the pouch to release more fragrance.",
    },
    {
      question: "5. Can I reuse or refill the pouches?",
      answer:
        "Yes! You can change the pads and add 2-3 drops of extra SAH? essence to refresh your pouch.",
    },
    {
      question: "6. Do you ship internationally?",
      answer:
        "Currently, we ship within the UAE only. International shipping is coming soon!",
    },
    {
      question: "7. What is your exchange and return policy?",
      answer:
        "We do not offer exchanges or returns. Please choose your scent carefully before placing your order.",
    },
    {
      question: "8. Are the scents safe for pets?",
      answer:
        "Our scents are made with safe, non-toxic ingredients. However, please keep them out of reach of pets and children.",
    },
    {
      question: "9. How do I choose the right scent?",
      answer:
        "Browse by mood or collection. Each scent is designed to match a vibe—whether you want energy, calm, nostalgia, or pride.",
    },
  ];

  return (
    <section className="faq-page">

      <div className="faq-container">

        <span className="faq-small">
          SUPPORT
        </span>

        <h1>
          Frequently Asked Questions
        </h1>

        <p className="faq-description">
          Everything you need to know about SAH? scented pouches.
        </p>

        <div className="faq-list">

          {faqs.map((faq, index) => (

            <details key={index} className="faq-item">

              <summary>
                {faq.question}
              </summary>

              <p>
                {faq.answer}
              </p>

            </details>

          ))}

        </div>

      </div>

    </section>
  );
}

export default Faq;